"use client";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { ScrollArea } from "~/components/ui/scroll-area";
import { sanitizeCompanyProfileMarkdown } from "~/components/siteglue/siteglue-extended-knowledge-panel";

type HireWizardCompanyProfileDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  businessName: string;
  profileText: string;
};

const PROSE =
  "prose prose-sm max-w-none text-slate-800 prose-headings:mb-2 prose-headings:mt-4 prose-headings:font-semibold prose-headings:text-slate-900 prose-hr:my-3 prose-li:my-0.5 prose-p:my-2 prose-p:leading-relaxed prose-strong:font-semibold [&>*:first-child]:mt-0";

export function HireWizardCompanyProfileDialog({
  open,
  onOpenChange,
  businessName,
  profileText,
}: HireWizardCompanyProfileDialogProps) {
  const displayText = sanitizeCompanyProfileMarkdown(profileText);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] max-w-2xl">
        <DialogHeader>
          <DialogTitle>Organization profile — {businessName}</DialogTitle>
        </DialogHeader>
        <ScrollArea className="max-h-[65vh] pr-4">
          {displayText.trim() ? (
            <div className="rounded-xl border border-slate-200 bg-slate-50/80 p-4 sm:p-5">
              <ReactMarkdown remarkPlugins={[remarkGfm]} className={PROSE}>
                {displayText}
              </ReactMarkdown>
            </div>
          ) : (
            <p className="text-sm leading-relaxed text-slate-700">
              No company profile generated yet.
            </p>
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
